export default "__VITE_ASSET__Kjr4ae6B__"